import { render, staticRenderFns } from "./OperationDefinitionsListCard.vue?vue&type=template&id=effbda16&scoped=true&"
import script from "./OperationDefinitionsListCard.vue?vue&type=script&lang=js&"
export * from "./OperationDefinitionsListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effbda16",
  null
  
)

export default component.exports